import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { PageHeader, Result, Button, Spin } from 'antd';
import { MyBreadcrumb, accessControls } from 'utils';
import TimeTrackerUserGroupForm from './form';

export default function TimeTrackerUserGroupCreate() {
  const history = useHistory();
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    accessControls
      .fetch()
      .then(setPermissions)
      .catch(() => setPermissions({}));
  }, []);

  if (permissions == null) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }
  if (!accessControls.can(permissions, 'TimeTrackerUserGroup.create:any')) {
    return (
      <div style={{ padding: 24 }}>
        <Result
          status="403"
          title="Access denied"
          subTitle="You do not have permission to create user groups."
          extra={
            <Button type="primary" onClick={() => history.push('/')}>
              Go to Dashboard
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Time Tracker', path: '/time-tracker/tracker' },
          { label: 'User groups', path: '/time-tracker/user-groups' },
          { label: 'Create', path: '' },
        ]}
      />
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Create user group"
        subTitle="Add users to a group so you can grant project access in bulk"
      >
        <TimeTrackerUserGroupForm />
      </PageHeader>
    </div>
  );
}
